import React, { PropsWithChildren } from 'react';
import { Box, Button, Modal, Text } from '@razorpay/blade/components';
import ActionModal from '../components/ActionModal';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onDismiss: () => void;
  isLoading?: boolean;
  componentName: string;
  onSubmit: () => void;
}>;

const EnableModal = ({ componentName, isOpen, onDismiss, onSubmit, isLoading, children }: Props) => {
  return (
    <ActionModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      headingText={`Enable ${componentName} ?`}
      submitButton={
        <Button
          testID={`enable-component-button`}
          size={'medium'}
          onClick={onSubmit}
          color={'positive'}
          isLoading={isLoading}>
          Enable Now
        </Button>
      }>
      {children}
    </ActionModal>
  );
};

export default EnableModal;
